import { authenticatedApiCall } from '@/api/authenticatedApiCall'
import { defineStore } from 'pinia'
import { computed, ref, watchEffect } from 'vue'
import dayjs from 'dayjs'

export const useNotifyStore = defineStore('notifyStore', () => {
  // сделать нормальное запоминание непрочитанных хотя б через local storage
  const fromBackground = ref(false)
  const fromNotifyView = ref(false)
  const notificationList = ref([])
  const notifyCount = ref(0)
  const serverStoredNotifications = ref([])

  const setFromBackground = (isBackground) => {
    fromBackground.value = isBackground
  }
  const setNotification = (payload) => {
    let notifyData = {}
    if (payload?.action === 'assist') {
      notifyData = {
        action: payload.action,
        user_id: payload?.user_id,
        id: payload.message_id,
        title: payload.title,
        message: payload.message,
        routerUrl: payload.routerUrl,
        externalUrl: '',
        pid: payload.pid,
        created_at: payload?.created_at || dayjs(payload?.created_at).format('YYYY-MM-DD HH:mm:ss'),
        wasChecked: false
      }
    } else {
      notifyData = {
        title: payload.title,
        message: payload.body,
        routerUrl: payload.routerUrl,
        externalUrl: payload.externalUrl,
        pid: payload.pid,
        created_at: payload?.created_at || dayjs(payload?.created_at).format('YYYY-MM-DD HH:mm:ss'),
        wasChecked: false
      }
    }
    notificationList.value.unshift(notifyData)
  }

  const checkNotify = () => {
    notificationList.value.forEach((notify) => {
      notify.wasChecked = true
    })
  }

  const checkAiChatNotifications = () => {
    notificationList.value.forEach((notify) => {
      if (notify?.action === 'assist') {
        notify.wasChecked = true
      }
    })
  }

  const allNotifications = computed(() => {
    const allNotify = [...notificationList.value, ...serverStoredNotifications.value]
    const uniquePid = {}
    for (let i = 0; i < allNotify.length; i++) {
      uniquePid[allNotify[i].pid] = allNotify[i]
    }

    return Object.values(uniquePid).sort((notifyA, notifyB) =>
      notifyA.pid > notifyB.pid ? -1 : 1
    )
  })

  const getServerStoredNotifications = async () => {
    try {
      const response = await authenticatedApiCall({ url: 'v3/push' })

      if (response.data.status === 'ok') {
        serverStoredNotifications.value = response.data.data
      }
    } catch (e) {
      serverStoredNotifications.value = []
    }
  }

  watchEffect(() => {
    // console.log('all notifications from store', allNotifications.value)
  })

  return {
    fromBackground,
    notificationList,
    notifyCount,
    fromNotifyView,
    allNotifications,
    setNotification,
    setFromBackground,
    checkNotify,
    getServerStoredNotifications,
    checkAiChatNotifications
  }
})
